<div mat-dialog-content class="form-container">
  <form [formGroup]="datosInstalacion">
    <h1>Alta Instalación</h1>
    <div>
      <h2>Datos Instalación</h2>
      <mat-form-field appearance="outline">
        <mat-label>Nombre de la Instalación</mat-label>
        <input
          matInput
          placeholder="Nombre de la Instalación"
          formControlName="nombre"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Cliente Asignado</mat-label>
        <input
          matInput
          placeholder="Cliente asignado"
          formControlName="cliente"
          required
        />
      </mat-form-field>
    </div>
    <div>
      <h2>Zonas y Grupos</h2>
      <mat-form-field appearance="outline">
        <mat-label>Grupo</mat-label>
        <input matInput placeholder="Grupo asignado" formControlName="grupo" />
      </mat-form-field>
      <div>
        <button
          type="submit"
          (click)="addInstalacion()"
          [mat-dialog-close]
          [disabled]="datosInstalacion.invalid"
        >
          Hecho
        </button>
      </div>
    </div>
  </form>
</div>
